import { inject, Injectable, OnDestroy } from '@angular/core'
import { SwUpdate } from '@angular/service-worker'
import { LocalStorageService } from './local-storage.service'
import { tap } from 'rxjs/operators'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class NewVersionCheckerService implements OnDestroy {
  private swUpdate = inject(SwUpdate)
  private storage = inject(LocalStorageService)

  private versionUpdateSub = this.swUpdate.versionUpdates
    .pipe(
      tap((evt) => {
        switch (evt.type) {
          case 'NO_NEW_VERSION_DETECTED':
            console.log(`No new app version detected`)
            break
          case 'VERSION_DETECTED':
            console.log(`Downloading new app version: ${evt.version.hash}`)
            break
          case 'VERSION_READY':
            console.log(`Current app version: ${evt.currentVersion.hash}`)
            console.log(
              `New app version ready for use: ${evt.latestVersion.hash}`,
            )
            this.updateNow()
            break
          case 'VERSION_INSTALLATION_FAILED':
            console.log(
              `Failed to install app version '${evt.version.hash}': ${evt.error}`,
            )
            break
        }
      }),
    )
    .subscribe()

  private updated = new Subject<string>()
  public updated$ = this.updated.asObservable()

  constructor() {
    // updated message
    const versionUpdated = this.storage.getItem('versionUpdated')
    if (versionUpdated) {
      console.log('Version updated')
      this.storage.removeItem('versionUpdated')
      this.updated.next(new Date().toISOString())
    }
  }

  ngOnDestroy(): void {
    if (this.versionUpdateSub && this.versionUpdateSub.unsubscribe) {
      this.versionUpdateSub.unsubscribe()
      this.versionUpdateSub = null
    }
  }

  public async checkForUpdate() {
    if (!this.swUpdate.isEnabled) {
      // exit early if service worker is not enabled
      console.log('checkForUpdate EXIT: swUpdate not isEnabled')
      return
    }
    try {
      const result = await this.swUpdate.checkForUpdate()
      console.log('checkForUpdate result:', result)
      if (result) {
        this.updateNow()
      }
    } catch (error) {
      console.error('checkForUpdate error:', error)
    }
  }

  public updateNow() {
    this.storage.setItem('versionUpdated', true)
    window.location.reload()
  }
}
